import React, {Fragment, useEffect, useState} from 'react';
import {Spin} from "antd";
import {ImageNotFound} from "../../../assets/images/placeholder";

export enum IMAGE_LOAD_STATUS { LOADING, SUCCESS, ERROR}

interface IProps {
    src: string;
    alt?: string;
    width?: string;
    height?: string;
    style?:object,
    className?:string,
    showLoading?: boolean;
    showNotFoundImage?: boolean;
    [key: string]: any,
}

const HttpImage: React.FC<IProps> = props => {
    const { src, alt = '', showLoading = false, showNotFoundImage = false, ...restProps } = props;
    const [imageSrc, setImageSrc] = useState('');
    const [imageLoadedStatus, setImageLoadedStatus] = useState(IMAGE_LOAD_STATUS.LOADING);

    useEffect(() => {
        setImageLoadedStatus(IMAGE_LOAD_STATUS.LOADING);

        if (src === "" || src === null ||  src === undefined) {
            setImageSrc('');
            setImageLoadedStatus(IMAGE_LOAD_STATUS.ERROR)
        }
        else {
            try {
                const img = new Image()
                const imgUrl = src;

                img.src = imgUrl
                img.onload = () => {
                    setImageSrc(imgUrl);
                    setImageLoadedStatus(IMAGE_LOAD_STATUS.SUCCESS)
                    img.remove()
                }
                img.onerror = () => {
                    setImageSrc('');
                    setImageLoadedStatus(IMAGE_LOAD_STATUS.ERROR)
                    img.remove()
                }
            }
            catch {
                setImageSrc('');
                setImageLoadedStatus(IMAGE_LOAD_STATUS.ERROR)
            }
        }

    }, [src])

    return (
        <>
            {showLoading && imageLoadedStatus === IMAGE_LOAD_STATUS.LOADING && (
                <Spin size="small" />
            )}

            {showNotFoundImage && imageLoadedStatus === IMAGE_LOAD_STATUS.ERROR && (
                <img src={ImageNotFound} alt={alt} {...restProps} />
            )}

            {imageLoadedStatus === IMAGE_LOAD_STATUS.SUCCESS && (
                <img src={imageSrc} alt={alt} {...restProps} />
            )}
        </>
    );
}

export default React.memo(HttpImage);